var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#FF6E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6041 6.35416C12.6041 6.06651 12.8373 5.83333 13.125 5.83333H16.7708C17.0585 5.83333 17.2916 6.06651 17.2916 6.35416V10C17.2916 10.2876 17.0585 10.5208 16.7708 10.5208C16.4832 10.5208 16.25 10.2876 16.25 10V7.61157L12.1466 11.7149C12.1466 11.7149 12.1466 11.7149 12.1466 11.715C12.0015 11.8601 11.8292 11.9752 11.6397 12.0537C11.4501 12.1323 11.2469 12.1727 11.0416 12.1727C10.8364 12.1727 10.6332 12.1323 10.4436 12.0537C10.254 11.9752 10.0818 11.86 9.93667 11.7149L8.28502 10.0633L8.28497 10.0632C8.23661 10.0148 8.17919 9.97647 8.11599 9.95029C8.05279 9.92411 7.98505 9.91063 7.91665 9.91063C7.84824 9.91063 7.7805 9.92411 7.7173 9.95029C7.65411 9.97647 7.59668 10.0148 7.54832 10.0632L7.54828 10.0633L3.59743 14.0141C3.39403 14.2175 3.06426 14.2175 2.86086 14.0141C2.65746 13.8107 2.65746 13.4809 2.86086 13.2775L6.81167 9.32674C6.95676 9.18161 7.12903 9.06649 7.31862 8.98794C7.50822 8.90939 7.71143 8.86897 7.91665 8.86897C8.12187 8.86897 8.32508 8.90939 8.51467 8.98794C8.70427 9.06649 8.87653 9.18161 9.02163 9.32674L10.6733 10.9784L10.6733 10.9784C10.7217 11.0268 10.7791 11.0652 10.8423 11.0914C10.9055 11.1175 10.9732 11.131 11.0416 11.131C11.1101 11.131 11.1778 11.1175 11.241 11.0914C11.3042 11.0652 11.3616 11.0268 11.41 10.9784L11.41 10.9784L15.5134 6.87499H13.125C12.8373 6.87499 12.6041 6.64181 12.6041 6.35416Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.87036d53826d576fecd04cb56d1d5168.svg";
export { ForwardRef as ReactComponent };